
import { Component, Prop, Vue } from 'vue-property-decorator'
import { NavBar, CallConfigModal } from '@/components'
import store from '../store'
import FetchWrapper from '@/classes/fetchWrapper'

class SocketioService {
  socket
  io
  callId
  localStream
  usersList
  devices
  activeVideoWebsocketId
  iceConfiguration
  /* outputAudioEl
  outputAudioStream */

  constructor (io, callId, iceConfiguration) {
    this.usersList = []
    this.devices = []
    this.activeVideoWebsocketId = null
    /* this.outputAudioStream = new MediaStream()
    this.outputAudioEl = new Audio()
    this.outputAudioEl.srcObject = this.outputAudioStream */
    // this.io = io('/call')
    // this.io = io('ws://localhost:3000/call', { path: '/socket.io' })
    // this.io = io('http://192.168.0.228:3000', { path: '/socket.io' })
    // this.io = io('https://192.168.0.228:3000', { path: '/call/socket.io' })
    this.io = io
    this.callId = callId
    this.iceConfiguration = iceConfiguration
    this.init()
  }

  async terminateSocketConnection () {
    await this.socket.disconnect()
  }

  setupSocketConnection () {
    this.socket = this.io.connect(`${process.env.VUE_APP_SERVERURL}/call`, {
      auth: {
        token: store.getters.getAccessToken
      },
      path: '/socket.io'
    })

    this.socket.on('update-user-list', ({ users }) => {
      this.updateUserList(users)
    })

    this.socket.on('update-user-list-and-call', ({ users }) => {
      this.updateUserList(users, true)
    })

    this.socket.on('remove-user', ({ socketId }) => {
      const elToRemoveIdx = this.usersList.findIndex(item => item.socketId === socketId)
      if (elToRemoveIdx > -1) {
        /* for (var i = 0; i < this.usersList[elToRemoveIdx].senders.length; i++) {
          this.usersList[elToRemoveIdx].peerConnection.removeTrack(this.usersList[elToRemoveIdx].senders[i])
        } */
        this.usersList[elToRemoveIdx].peerConnection.close()
        this.usersList.splice(elToRemoveIdx, 1)
      }
      if (socketId === this.activeVideoWebsocketId) {
        var activeVideo = document.getElementById('active-video')
        if (activeVideo) {
          activeVideo.srcObject = this.localStream // TODO: SHOULDN'T IT GET VIDEO TRACK TO SET IT TO SRC OBJECT?
          this.activeVideoWebsocketId = null
        }
      }
    })

    this.socket.on('call-made', async data => {
      var userIdx = this.usersList.findIndex(item => item.socketId === data.socket)
      if (userIdx > -1) {
        this.usersList[userIdx].isAlreadyCalling = true
        await this.usersList[userIdx].peerConnection.setRemoteDescription(
          new RTCSessionDescription(data.offer)
        )
        const answer = await this.usersList[userIdx].peerConnection.createAnswer()
        await this.usersList[userIdx].peerConnection.setLocalDescription(new RTCSessionDescription(answer))
        this.socket.emit('make-answer', {
          answer,
          to: data.socket,
          callId: this.callId
        })
      }
    })

    this.socket.on('answer-made', async data => {
      var userIdx = this.usersList.findIndex(item => item.socketId === data.socket)
      if (userIdx > -1) {
        await this.usersList[userIdx].peerConnection.setRemoteDescription(
          new RTCSessionDescription(data.answer)
        )
        if (!this.usersList[userIdx].isAlreadyCalling) {
          this.usersList[userIdx].isAlreadyCalling = true
          this.callUser(data.socket)
        }
      }
    })

    this.socket.on('negotiate-offered', async data => {
      var userIdx = this.usersList.findIndex(item => item.socketId === data.socket)
      if (userIdx > -1) {
        await this.usersList[userIdx].peerConnection.setRemoteDescription(
          new RTCSessionDescription(data.offer)
        )
        const answer = await this.usersList[userIdx].peerConnection.createAnswer()
        await this.usersList[userIdx].peerConnection.setLocalDescription(new RTCSessionDescription(answer))
        this.socket.emit('negotiate-answer', {
          answer,
          to: data.socket,
          callId: this.callId
        })
      }
    })

    this.socket.on('negotiate-answered', async data => {
      var userIdx = this.usersList.findIndex(item => item.socketId === data.socket)
      if (userIdx > -1) {
        await this.usersList[userIdx].peerConnection.setRemoteDescription(
          new RTCSessionDescription(data.answer)
        )
      }
    })

    this.socket.on('drop-call', async () => {
      // TODO: inform user and disconnect socket connection and reload page
      await this.leaveCall()
    })

    this.socket.on('unauthorized', async () => {
      this.$buefy.dialog.confirm({
        title: 'Unauthorized',
        message: 'You are not allowed to join this call at this time. Check if you were invited to it and if you are in time. Calls hangup 45 minutes late. Check the scheduled time.',
        onConfirm: async () => {
          this.localStream.getTracks().forEach(t => t.stop())
          await this.terminateSocketConnection()
          window.location.href = '/home/calls'
        },
        canCancel: false
      })
    })

    this.socket.on('connect_error', (err) => {
      this.$buefy.dialog.confirm({
        title: 'Connection Error',
        message: err.message,
        canCancel: false
      })
    })

    this.socket.on('disconnect', (err) => {
      console.log(`socket disconnected = ${err.message}`)
    })
  }

  async init () {
    // await this.checkVideoAvailable()
    await this.startLocalVideo()
    this.setupSocketConnection()
  }

  async checkVideoAvailable () {
    try {
      this.devices = await navigator.mediaDevices.enumerateDevices()
      /* this.devices.forEach((device) => {
        console.log(`${device.kind}: ${device.label} id = ${device.deviceId}`)
      }) */
    } catch (e) {
      console.error(e)
    }
  }

  async setLocalStreamVideoTrack (newTrack) {
    var tracks = this.localStream.getVideoTracks()
    if (tracks.length > 1) {
      console.error('there is more than one video track for local video stream.')
    } else if (tracks.length === 1) {
      this.localStream.removeTrack(tracks[0])
    }
    if (newTrack) {
      this.localStream.addTrack(newTrack)
    }
    this.updateLocalVideo()

    this.usersList.forEach((item) => {
      var senders = item.peerConnection.getSenders()
      for (var i = 0; i < senders.length; i++) {
        if (senders[i].track == null || senders[i].track.kind === 'video') {
          item.peerConnection.removeTrack(senders[i])
        }
      }
      if (newTrack) {
        item.peerConnection.addTrack(newTrack, this.localStream)
      }
    })
  }

  async setLocalStreamAudioTrack (newTrack) {
    var tracks = this.localStream.getAudioTracks()
    if (tracks.length > 1) {
      console.error('there is more than one audio track for local audio stream.')
    } else if (tracks.length === 1) {
      this.localStream.removeTrack(tracks[0])
    }
    if (newTrack) {
      this.localStream.addTrack(newTrack)
    }

    this.usersList.forEach((item) => {
      var senders = item.peerConnection.getSenders()
      for (var i = 0; i < senders.length; i++) {
        if (senders[i].track == null || senders[i].track.kind === 'audio') {
          item.peerConnection.removeTrack(senders[i])
        }
      }
      if (newTrack) {
        item.peerConnection.addTrack(newTrack, this.localStream)
      }
    })
  }

  changeActiveSenderAudio (value) {
    this.usersList.forEach((item) => {
      var senders = item.peerConnection.getSenders()
      for (var i = 0; i < senders.length; i++) {
        if (senders[i] && senders[i].track && senders[i].track.kind === 'audio') {
          senders[i].track.enabled = value
        }
      }
    })
  }

  async startLocalVideo () {
    try {
      this.localStream = new MediaStream([])
    } catch (e) {
      console.error(e.message)
    }
  }

  async updateLocalVideo () {
    var activeVideoEl = document.getElementById('active-video')
    var localVideo = document.getElementById('localvideo')
    var streamvid = this.localStream.getVideoTracks()
    if (streamvid.length > 0) {
      var videoStream = new MediaStream([streamvid[0]])
      if (activeVideoEl) {
        activeVideoEl.srcObject = videoStream
      }
      if (localVideo) {
        localVideo.srcObject = videoStream
      }
    } else {
      if (activeVideoEl) {
        activeVideoEl.srcObject = null
      }
      if (localVideo) {
        localVideo.srcObject = null
      }
    }
  }

  async joinCall () {
    this.socket.emit('join-call', {
      callId: this.callId
    })
    // this.outputAudioEl.play()
  }

  async leaveCall () {
    this.socket.emit('leave-call', {
      callId: this.callId
    }, this.afterLeftCall.bind(this))
  }

  async afterLeftCall () {
    this.usersList.forEach((item) => {
      var senders = item.peerConnection.getSenders()
      for (var i = 0; i < senders.length; i++) {
        item.peerConnection.removeTrack(senders[i])
      }
      item.peerConnection.close()
    })
    this.localStream.getTracks().forEach(t => t.stop())
    await this.terminateSocketConnection()
    this.usersList = []
    confirm('Call has reached end. We have disconnected it for you.', () => {
      // window.location.reload()
      window.location.href = '/home/calls'
    })
    // this.outputAudioEl.pause()
  }

  async callUser (socketId) {
    var userIdx = this.usersList.findIndex(item => item.socketId === socketId)
    if (userIdx === -1) {
      return
    }
    var hasRemoteOffer = this.usersList[userIdx].peerConnection.signalingState === 'have-remote-offer'
    if (hasRemoteOffer) {
      setTimeout(() => { this.callUser(socketId) }, 1000)
    } else {
      const offer = await this.usersList[userIdx].peerConnection.createOffer({ offerToReceiveVideo: true, offerToReceiveAudio: true })
      await this.usersList[userIdx].peerConnection.setLocalDescription(new RTCSessionDescription(offer))

      this.socket.emit('call-user', {
        offer,
        to: socketId,
        callId: this.callId
      })
    }
  }

  async fireNegotiation (event) {
    var peerConnection = event.target
    var userIdx = this.usersList.findIndex(item => item.socketId === peerConnection.clientSocketId)
    if (userIdx === -1) {
      return
    }
    if (!this.usersList[userIdx].isAlreadyCalling) {
      return
    }
    var offer = await peerConnection.createOffer({ offerToReceiveVideo: true, offerToReceiveAudio: true })
    await peerConnection.setLocalDescription(new RTCSessionDescription(offer))
    this.socket.emit('negotiate-offer', {
      offer,
      to: peerConnection.clientSocketId,
      callId: this.callId
    })
  }

  async onTrack (event) {
    var peerConnection = event.target
    var [stream] = event.streams
    const remoteVideo = document.getElementById(`${peerConnection.clientSocketId}-remote-video`)
    if (remoteVideo) {
      remoteVideo.srcObject = stream
    }
    if (peerConnection.clientSocketId === this.activeVideoWebsocketId) {
      var activeVideo = document.getElementById('active-video')
      if (activeVideo) {
        var source = document.getElementById(`${this.activeVideoWebsocketId}-remote-video`)
        activeVideo.srcObject = source.srcObject
      }
    }

    stream.onremovetrack = ({ track }) => {
      /* if (!stream.getTracks().length) {
        console.log(`stream ${stream.id} emptied (effectively removed).`)
      } */
      if (track.kind === 'video') {
        remoteVideo.srcObject = null
        if (peerConnection.clientSocketId === this.activeVideoWebsocketId) {
          var activeVideo = document.getElementById('active-video')
          if (activeVideo) {
            // activeVideo.srcObject = null
            activeVideo.srcObject = this.localStream // TODO: SHOULDN'T IT GET VIDEO TRACK TO SET IT TO SRC OBJECT?
            this.activeVideoWebsocketId = null
          }
        }
      }
    }
    /* var audioTracks = stream.getAudioTracks()
    if (audioTracks.length > 0) {
      this.outputAudioStream.addTrack(audioTracks[0])
    } else {
      console.error(`socket id ${peerConnection.clientSocketId} nao tem track de audio`)
    } */
  }

  updateUserList (list, shouldCall) {
    for (var i = 0; i < list.length; i++) {
      var socketId = list[i].socketId
      // console.error(`socketId = ${socketId}`)
      const alreadyExistingUser = this.usersList.find(item => item.socketId === socketId)
      if (!alreadyExistingUser) {
        const { RTCPeerConnection, RTCSessionDescription } = window
        var peerConnection = new RTCPeerConnection()
        peerConnection.setConfiguration(this.iceConfiguration)
        // peerConnection.restartIce();
        peerConnection.addEventListener('track', this.onTrack.bind(this))
        peerConnection.onclose = () => { console.log(`terminating peerconnection for socket id = ${socketId}`) }
        peerConnection.clientSocketId = socketId
        peerConnection.addEventListener('negotiationneeded', this.fireNegotiation.bind(this))

        const tracks = this.localStream.getTracks()
        // var senders = []
        for (var j = 0; j < tracks.length; j++) {
          // senders.push(peerConnection.addTrack(tracks[j], this.localStream))
          peerConnection.addTrack(tracks[j], this.localStream)
        }

        this.usersList.push({
          userName: list[i].userName,
          socketId,
          peerConnection
        })

        if (shouldCall) {
          this.callUser(socketId)
        }
      }
    }
  }
}
// https://deepinder.me/creating-a-real-time-chat-app-with-vue-socket-io-and-nodejs
Vue.prototype.$multiwatch = function (props, watcher) {
  var iterator = function (prop) {
    this.$watch(prop, watcher)
  }
  props.forEach(iterator, this)
}

@Component({
  components: {
    NavBar,
    CallConfigModal
  }
})
export default class CallView extends Vue {
  data () {
    return {
      openConfigModal: true,
      videoAudioStream: null,
      audioStream: null,
      // recordedChunks: [],
      mediaRecorders: {},
      lastRecorderStartTimer: null,
      // uploadChunkCount: null,
      recorderStopped: false,
      recorderStartTimer: null,
      playerInterval: null,
      recordingEnded: false,
      callActive: false,
      callId: null,
      micAverage: 0,
      // analyser: null,
      workletNode: null,
      audioSource: null,
      socketioService: { usersList: [] },
      base_url: process.env.BASE_URL,
      openCameraModal: false,
      innerHeight: 0,
      muteMicLockState: 'auto',
      muteMic: false,
      muteCamera: false,
      localVideoTrack: null,
      localAudioTrack: null,
      timer: 0,
      timerInterval: null,
      timerMins: 0,
      timerSecs: 0,
      showTimer: true,
      activeVideoBorderRadius: '50%',
      waitingToStartMessage: 'Call will start automatically in',
      waitingToJoin: null,
      micThreshold: 10,
      // recordBuffer: [],
      recordBuffers: {},
      showWord: false,
      word: ''
    }
  }

  mounted () {
    this.updateInnerHeight()
    this.loadBackgroundImg()
    this.callId = this.$route.params.callId
    this.getChunkCount()
    this.initMediaDevices()
    this.$multiwatch(['muteCamera'], function () {
      var track = null
      if (!this.muteCamera) {
        track = this.localVideoTrack
      }
      if (this.socketioService) {
        this.socketioService.setLocalStreamVideoTrack(track)
      }
    })
    /* this.$multiwatch(['muteMic'], function () {
    }) */
  }

  updateMuteMic (value) {
    if (this.muteMic !== value) {
      this.muteMic = value
      console.log('updateMuteMic = ', this.muteMic)
      // var track = null
      if (!this.muteMic) {
        // track = this.localAudioTrack
        // this.localAudioTrack.enabled = true
        this.socketioService.changeActiveSenderAudio(true)
        this.startRecordAudio()
      } else {
        // this.localAudioTrack.enabled = false
        this.socketioService.changeActiveSenderAudio(false)
        this.stopRecordAudio()
      }
      // this.socketioService.setLocalStreamAudioTrack(track)
      // // this.updateRecordAudioTrack(track)
    }
  }

  updateInnerHeight () {
    this.innerHeight = window.innerHeight
    window.addEventListener('resize', (event) => {
      this.innerHeight = window.innerHeight
    })
  }

  async loadSocketClientIoJs () {
    return new Promise((resolve, reject) => {
      const recaptchaScript = document.createElement('script')
      recaptchaScript.onload = () => {
        var socketioService = new SocketioService(window.io, this.callId, this.iceConfiguration)
        resolve(socketioService)
      }
      recaptchaScript.orerror = () => {
        reject(new Error('could not load socket.io lib.'))
      }
      recaptchaScript.setAttribute(
        'src',
        `${window.location.protocol}//${window.location.host}/scripts/socket.io.js`
      )
      document.head.appendChild(recaptchaScript)
    })
  }

  loadBackgroundImg () {
    const el = document.createElement('img')
    el.setAttribute(
      'src',
      'http://localhost:8080/images/illustrations/leaf-bg.png'
    )
    el.setAttribute(
      'alt',
      'bg-shape'
    )
    el.style.position = 'absolute'
    el.style.width = '100%'
    el.style.margin = '0px'
    el.style.padding = '0px'
    el.style.height = '100%'
    el.style.opacity = '20%'
    el.style.display = 'initial'
    el.style.top = '0px'
    el.style.opacity = '0.1'
    var container = document.getElementById('active-video-container')
    container.prepend(el)
  }

  async getChunkCount () {
    this.isLoading = true
    try {
      var resp = await FetchWrapper.get(encodeURI(`${process.env.VUE_APP_SERVERURL}/getLastChunkIdx/${this.callId}`))
      // this.uploadChunkCount = resp.lastChunkIdx + 1
      // this.uploadChunkCount = 1
      // TODO: trocar mocked timer pelo verdadeiro
      this.timer = resp.diff
      // this.timer = -10000
      this.timerInterval = setInterval(this.updateTimer, 1000)
      this.isLoading = false
    } catch (e) {
      this.isLoading = false
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: e,
        onConfirm: () => { window.location.href = '/home/calls' },
        canCancel: false
      })
    }
  }

  async getNextWord () {
    this.isLoading = true
    try {
      var resp = await FetchWrapper.get(encodeURI(`${process.env.VUE_APP_SERVERURL}/getNextWord`))
      this.word = resp.expression
      this.isLoading = false
    } catch (e) {
      this.isLoading = false
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: 'Could not get next word.',
        canCancel: false
      })
    }
  }

  async getIceCredentials () {
    this.isLoading = true
    try {
      var resp = await FetchWrapper.get(encodeURI(`${process.env.VUE_APP_SERVERURL}/getIceCredentials/${this.callId}`))
      this.iceConfiguration = {
        iceServers: [
          {
            urls: resp.url,
            username: resp.username,
            credential: resp.password
          }
        ]
      }

      this.isLoading = false
    } catch (e) {
      this.isLoading = false
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: 'Could not get ice credentials.',
        canCancel: false
      })
    }
  }

  updateTimer () {
    this.timer += 1000
    var d = Math.abs(this.timer) / 1000 / 60
    var mins = Math.floor(d)
    var secs = Math.floor((d - mins) * 60)
    this.timerMins = mins < 10 ? `0${mins}` : mins
    this.timerSecs = secs < 10 ? `0${secs}` : secs

    if (this.timer >= 1000 * 60 * 45 && this.callActive) {
      this.endCallElegantly()
    }
  }

  async initMediaDevices () {
    try {
      await this.getIceCredentials()
      this.socketioService = await this.loadSocketClientIoJs()
    } catch (err) {
      console.warn(err)
    }
  }

  /* async updateRecordAudioTrack (newTrack) {
    console.log('updating audio record track')
    var tracks = this.audioStream.getAudioTracks()
    if (tracks.length > 1) {
      console.error('there is more than one audio track for local audio stream.')
    } else if (tracks.length === 1) {
      this.audioStream.removeTrack(tracks[0])
    }
    if (newTrack) {
      console.log('adding track')
      this.audioStream.addTrack(newTrack)
      this.recorderStartTimer = Number(new Date())
      this.uploadChunkCount = 1
      this.mediaRecorder.start(1000)
    } else {
      console.log('this.audioStream tracks = 0')
    }
  } */

  /* async setupAudioProcessor () {
    // this.recordedChunks = []
    // this.uploadChunkCount = 0
    this.recordingEnded = false
    // this.audioStream = await navigator.mediaDevices.getUserMedia({ video: false, audio: true })
    this.audioStream = new MediaStream([this.localAudioTrack])

    var audioContext = new AudioContext() // or webkitAudioContext
    this.audioSource = audioContext.createMediaStreamSource(this.audioStream)
    this.javascriptNode = audioContext.createScriptProcessor(2048, 1, 1) // TODO: this will be deprecated soon. should be replaced by AudioWorkletNode:
    // https://developer.mozilla.org/en-US/docs/Web/API/AudioWorkletNode
    this.analyser = audioContext.createAnalyser()

    this.analyser.smoothingTimeConstant = 0.3
    this.analyser.fftSize = 1024

    this.audioSource.connect(this.analyser)
    this.analyser.connect(this.javascriptNode)
    // this.javascriptNode.connect(audioContext.destination)

    this.javascriptNode.onaudioprocess = this.audioAnalizerProcessor

    // var volume = audioContext.createGain();
    // source.connect(volume);
    // volume.connect(audioContext.destination);
    // volume.gain.value = 0;  //turn off the speakers
  } */

  async setupAudioProcessor () {
    // this.recordedChunks = []
    // this.uploadChunkCount = 0
    this.recordingEnded = false
    // this.audioStream = await navigator.mediaDevices.getUserMedia({ video: false, audio: true })
    try {
      this.audioStream = new MediaStream([this.localAudioTrack])

      var audioContext = new AudioContext() // or webkitAudioContext
      this.audioSource = audioContext.createMediaStreamSource(this.audioStream)

      await audioContext.audioWorklet.addModule('/audio/analyzer.js')

      this.workletNode = new AudioWorkletNode(audioContext, 'audio-analyser-processor', {
        outputChannelCount: [1]
      })

      this.workletNode.port.postMessage({ type: 'threshold', value: this.threshold })
      this.workletNode.port.postMessage({ type: 'micThreshold', value: this.micThreshold })
      this.workletNode.port.postMessage({ type: 'muteMicLockState', value: this.muteMicLockState })

      this.workletNode.port.onmessage = (event) => {
        const { micAverage, muteMic, newValue } = event.data
        this.micAverage = micAverage
        this.updateMuteMic(muteMic)
        // this.muteMic = muteMic
        console.log('muteMic = ', muteMic)
      }

      // https://developer.mozilla.org/en-US/docs/Web/API/AudioWorkletNode
      this.audioSource.connect(this.workletNode)
      this.workletNode.connect(this.audioContext.destination)
      // this.javascriptNode.connect(audioContext.destination)
    } catch (error) {
      console.error('Error initializing audio analyser:', error)
    }

    // var volume = audioContext.createGain();
    // source.connect(volume);
    // volume.connect(audioContext.destination);
    // volume.gain.value = 0;  //turn off the speakers
  }

  updateMicThreshold (value) {
    this.micThreshold = value
    this.workletNode.port.postMessage({ type: 'micThreshold', value: this.micThreshold })
  }

  async startRecordAudio () {
    const options = { mimeType: 'audio/webm' }
    var uploadChunkCount = 1
    var recorderStartTimer = Number(new Date())
    this.mediaRecorders[recorderStartTimer] = new MediaRecorder(this.audioStream, options)
    this.recordBuffers[recorderStartTimer] = {
      recordBuffer: [],
      uploadChunkCount: 1
    }
    this.lastRecorderStartTimer = recorderStartTimer
    this.mediaRecorders[recorderStartTimer].ondataavailable = this.handleDataAvailable.bind(this, recorderStartTimer)
    this.mediaRecorders[recorderStartTimer].onstop = this.handleRecorderStop

    // this.uploadChunkCount = 1
    this.mediaRecorders[recorderStartTimer].start(1000)
    this.removeOldRecordBuffers()
    this.removeOldMediaRecorders()
  }

  /* audioAnalizerProcessor () {
    var array = new Uint8Array(this.analyser.frequencyBinCount)
    this.analyser.getByteFrequencyData(array)
    var values = 0

    var length = array.length
    for (var i = 0; i < length; i++) {
      values += array[i]
    }

    var newValue = values / length
    if (newValue > this.threshold && this.micAverage < this.threshold) {
      this.micAverage = (this.micAverage + newValue) / 2
    } else {
      this.micAverage = (this.micAverage * 9 + newValue) / 10
    }
    if (this.muteMicLockState === 'auto') {
      if (this.micAverage > this.micThreshold) {
        this.muteMic = false
      } else {
        this.muteMic = true
      }
    }
    // console.log(`micAverage = ${this.micAverage}`)
  } */

  changeMuteMicState () {
    /* if (this.muteMicLockState === 'opened') {
      this.muteMicLockState = 'auto'
    } else if (this.muteMicLockState === 'auto') { */
    if (this.muteMicLockState === 'auto') {
      this.muteMicLockState = 'closed'
      this.workletNode.port.postMessage({ type: 'muteMicLockState', value: this.muteMicLockState })
      // this.muteMic = true
      this.updateMuteMic(true)
    } else {
      this.muteMicLockState = 'auto'
      this.workletNode.port.postMessage({ type: 'muteMicLockState', value: this.muteMicLockState })
      // this.muteMic = false
    }
  }

  handleRecorderStop () {
    this.recorderStopped = true
    // this.uploadChunkCount = 0
  }

  stopRecordAudio () {
    this.recordingEnded = true
    // this.mediaRecorder.stop()
    this.mediaRecorders[this.lastRecorderStartTimer].stop()
    // clearInterval(this.playerInterval)
    // this.playerInterval = null
    // this.uploadToServer(this.recordedChunks.splice(0, this.recordedChunks.length), this.uploadChunkCount)
  }

  async handleDataAvailable (recorderStartTimer, event) { // , recordBuffer, uploadChunkCount) {
    if (event.data.size > 0) {
      if (this.recordBuffers[recorderStartTimer].recordBuffer.length === 0) {
        // if (!this.muteMic) {
        this.recordBuffers[recorderStartTimer].recordBuffer = [event.data]
        await this.uploadToServer(recorderStartTimer)
        this.recordBuffers[recorderStartTimer].uploadChunkCount = this.recordBuffers[recorderStartTimer].uploadChunkCount + 1
        this.recordBuffers[recorderStartTimer].recordBuffer = []
        // }
      } else {
        /* if (this.muteMic) {
          if (this.uploadChunkCount === 1) {
            this.recordBuffer = []
            // this.uploadChunkCount = 1
          } else {
            this.uploadToServer(this.recordBuffer, this.uploadChunkCount)
            this.recordBuffer = []
            this.uploadChunkCount = 1
          }
        } else { */
        await this.uploadToServer(recorderStartTimer)
        this.recordBuffers[recorderStartTimer].recordBuffer = [event.data]
        this.recordBuffers[recorderStartTimer].uploadChunkCount = this.recordBuffers[recorderStartTimer].uploadChunkCount + 1
      }
    } else {
      // …
    }
  }

  async removeOldRecordBuffers () {
    var keys = Object.keys(this.recordBuffers)
    var tenSecsAgo = Number(new Date()) - 10000
    keys.map(key => {
      if (key < tenSecsAgo) {
        delete this.recordBuffers[key]
      }
      return 0
    })
  }

  async removeOldMediaRecorders () {
    var keys = Object.keys(this.mediaRecorders)
    var tenSecsAgo = Number(new Date()) - 10000
    keys.map(key => {
      if (key < tenSecsAgo) {
        delete this.mediaRecorders[key]
      }
      return 0
    })
  }

  async uploadToServer (recorderStartTimer) {
    const blob = new Blob(this.recordBuffers[recorderStartTimer].recordBuffer, { type: 'audio/webm; codecs=opus' })
    // filename = '2-5612112-1.webm'
    const formData = new window.FormData()
    formData.append(
      'file', blob
    )
    formData.append(
      'chunkIdx', this.recordBuffers[recorderStartTimer].uploadChunkCount
    )
    formData.append(
      'recorderStartTimer', recorderStartTimer
    )
    formData.append(
      'recordingEnded', this.recordingEnded
    )
    formData.append(
      'callId', this.callId
    )
    const resp = await FetchWrapper.postForm(`${process.env.VUE_APP_SERVERURL}/uploadAudioChunk`, formData)
  }

  async tryToStartCall () {
    if (this.timer > 0) {
      this.startCall()
    } else {
      this.waitingToJoin = setTimeout(this.startCall, Math.abs(this.timer))
    }
  }

  async startCall () {
    this.waitingToJoin = null
    this.callActive = true
    await this.setupAudioProcessor()
    this.startRecordAudio()
    await this.socketioService.joinCall()
    this.getNextWord()
    this.showWord = true
  }

  async stopCall () {
    if (this.waitingToJoin) {
      clearTimeout(this.waitingToJoin)
      this.waitingToJoin = null
    } else {
      await this.stopRecordAudio()
      setTimeout(async () => {
        // this.callActive = false
        /* this.stopRecordAudio()
        this.audioSource.disconnect(this.analyser)
        this.analyser.disconnect(this.javascriptNode) */
        await this.socketioService.leaveCall()
        window.location.reload()
        this.callActive = false
        // this.javascriptNode.disconnect(audioContext.destination)
      }, 1000)
    }
  }

  async endCallElegantly () {
    await this.stopRecordAudio()
    setTimeout(async () => {
      // this.audioSource.disconnect(this.analyser)
      // this.analyser.disconnect(this.javascriptNode)
      this.audioSource.disconnect(this.workletNode)
      this.workletNode.disconnect(this.audioContext.destination)
      await this.socketioService.leaveCall()
      this.callActive = false
      this.$buefy.dialog.confirm({
        title: 'Call ended',
        message: 'Thanks for joining. See you next time.',
        onConfirm: async () => {
          window.location.href = '/home/calls'
        },
        canCancel: false
      })
    }, 1000)
  }

  goHome () {
    window.location.href = '/home/calls'
  }

  selectCamera (socketId) {
    var userIdx = this.socketioService.usersList.findIndex(item => item.socketId === socketId)
    if (userIdx > -1) {
      var activeVideo = document.getElementById('active-video')
      if (activeVideo) {
        var source = document.getElementById(`${socketId}-remote-video`)
        activeVideo.srcObject = source.srcObject
        this.socketioService.activeVideoWebsocketId = socketId
      }
    }
  }

  selectLocalCamera () {
    var activeVideo = document.getElementById('active-video')
    if (activeVideo) {
      activeVideo.srcObject = this.socketioService.localStream
      this.socketioService.activeVideoWebsocketId = null
    }
  }

  updateVideoInput (track) {
    this.localVideoTrack = track
    if (!this.muteCamera && this.socketioService) {
      this.socketioService.setLocalStreamVideoTrack(this.localVideoTrack)
    }
  }

  updateAudioInput (track) {
    this.localAudioTrack = track
    if (!this.audioStream) {
      this.audioStream = new MediaStream([this.localAudioTrack])
    }
    if (!this.muteMic && this.socketioService) {
      const cloneTrack = this.localAudioTrack.clone()
      this.socketioService.setLocalStreamAudioTrack(cloneTrack)
    }
  }

  async logout () {
    this.isLoading = true
    try {
      await FetchWrapper.get(encodeURI(`${process.env.VUE_APP_SERVERURL}/logout`))
      this.isLoading = false
      this.$store.commit('loggedIn', false)
      this.$store.commit('accessToken', null)
      this.closeLoginModal = false
      window.location.href = '/home/calls'
    } catch (e) {
      this.isLoading = false
      this.$buefy.dialog.confirm({
        title: 'Unauthorized',
        message: `Could not logout. ${e}`,
        canCancel: false
      })
    }
  }
}
